import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global-store', () => {
    const isLeftNavCollapsed = ref(false);
    const toggleLeftNav = () => {
        isLeftNavCollapsed.value = !isLeftNavCollapsed.value
    }
    const setLeftNavCollapsed = (value) => {
        isLeftNavCollapsed.value = value;
    };

    return {
        isLeftNavCollapsed,
        toggleLeftNav,
        setLeftNavCollapsed
    }
});